
<template>
<div class='centermap'>
  <div v-loading="maploading" id="centermap" class="homepage-map"></div>
  <div class="tip" v-show="tabsIndex==0" :class="{'tipleft':tippos}">
    <div class="tipDiv flexDiv flexSA">
      <div class="tipli flexDiv" v-for="(item,index) in rainTip" :key="index" v-show="item.val>0">
        <img :src="item.src">
        <div class="flexDivCol rightTip">
          <div>{{item.name}}</div>
          <div>{{item.val}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="tip" v-show="tabsIndex==1" :class="{'tipleft':tippos}">
    <div class="tip_tab">水情</div>
    <div class="tip_con flexDiv">
      <div class="flexDiv tip_div" v-for="(item,index) in waterTip" :key="index">
        <img :src="item.src">
        <span>{{item.val}}</span>
      </div>
    </div>
  </div>
  <!-- 测站弹窗 -->
  <stationDialog ref="stationDialog"></stationDialog>
</div>
</template>

<script>
import * as L from 'leaflet'
import TyphoonMap from '@/components/typhoon_map'
import api from '@/api/homepage_ptcopy'
import wave from '@/components/stationDialog/wave'
import stationDialog from '@/components/stationDialog'
import config from '@/config'
import request from '@/utils/request'
import eventbus from '@/utils/eventbus'
import comprehensiveMapTypes from '@/store/types/comprehensiveMap'
require('@/assets/map/leaflet-easyPrint.js')
require('@/extend/leaflet-extend.js')
export default {
  props: ['tabsIndex', 'tippos', 'rainData'],
  components: {
    TyphoonMap,
    wave,
    stationDialog
  },
  data () {
    return {
      printer: null,
      typename: '',
      loading1: false,
      maploading: false,
      map: '',
      reservoirData: [],
      riverData: [],
      ylzMarkers: null,
      skzMarkers: null,
      hdzMarkers: null,
      glMarkers: null,
      masklayer: null,
      mapObj: {},
      // 弹窗数据
      rainTip: [
        {
          name: '0',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r0.png')
        },
        {
          name: '<10',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r0-10.png')
        },
        {
          name: '10-25',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r10-25.png')
        },
        {
          name: '25-50',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r25-50.png')
        },
        {
          name: '50-100',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r50-100.png')
        },
        {
          name: '100-250',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r100-250.png')
        },
        {
          name: '>250',
          val: 0,
          src: require('@/assets/homepage_img_ptcopy/r250.png')
        }
      ],
      waterTip: [
        { val: '未超警', src: require('@/assets/homepage_img_ptcopy/river.png') },
        { val: '超警', src: require('@/assets/homepage_img_ptcopy/river_cj.png') }
      ],
      waterData: [],
      timer: {},
      imageLayer: null,
      timearr: []
    }
  },
  computed: {},
  watch: {
    tabsIndex () {
      if (this.ylzMarkers) {
        this.ylzMarkers.clearLayers()
        this.ylzMarkers = null
      }
      if (this.hdzMarkers) {
        this.hdzMarkers.clearLayers()
        this.hdzMarkers = null
      }
      if (this.skzMarkers) {
        this.skzMarkers.clearLayers()
        this.skzMarkers = null
      }
      if (this.glMarkers) {
        this.glMarkers.clearLayers()
        this.glMarkers = null
      }
      if (this.tabsIndex === 0) {
        this.drawPoint(this.rainData, '雨量站')
      } else {
        this.getStatisticsRiverWater()
        this.getStatisticsReservoirWater()
      }
    },
    rainData: {
      handler: function (val, oldval) {
        if (this.ylzMarkers) {
          this.ylzMarkers.clearLayers()
          this.ylzMarkers = null
        }
        if (this.glMarkers) {
          this.glMarkers.clearLayers()
          this.glMarkers = null
        }
        if (this.tabsIndex === 0) {
          this.drawPoint(this.rainData, '雨量站')
        }
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    // 河道水情
    getStatisticsRiverWater () {
      api.getStatisticsRiverWater({
        SID: this.$store.state.sid
      }).then(res => {
        this.waterData = res.data.rows
        this.drawPoint(this.waterData, '河道站')
      })
    },
    // 水库水情
    getStatisticsReservoirWater () {
      api.getStatisticsReservoirWater({
        SID: this.$store.state.sid
      }).then(res => {
        this.reservoirData = res.data.rows
        this.drawPoint(this.reservoirData, '水库站')
      })
    },
    radioChange (mapType) {
      this.mapType = mapType
      if (this.mapObj.tileLayer) {
        this.map.removeLayer(this.mapObj.tileLayer)
      }
      if (this.mapObj.textLayer) {
        this.map.removeLayer(this.mapObj.textLayer)
      }
      this.leaflet(this.mapType, true)
    },
    leaflet (mapType, reload) {
      let map = ''
      this.mapObj = L.CreateTianDiTuMap('centermap', {
        mapType: mapType,
        minZoom: 10, // 最小缩放等级
        maxZoom: 18, // 最大缩放等级
        opacity: 0.7,
        crs: L.CRS.EPSG4490,
        zoomControl: false
      }, reload, this.map, true)
      map = this.mapObj.map.setView([28.33, 120.68], 11)
      if (!reload) {
        var myStyle = {
          'color': '#2dd9f8',
          'weight': 1,
          'opacity': 1
        }
        request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
          L.geoJSON(res.data, {
            style: myStyle
          }).addTo(map)
        })
        this.printer = L.easyPrint({
          sizeModes: ['Current', 'A4Landscape', 'A4Portrait'],
          filename: 'myMap',
          exportOnly: true,
          hideControlContainer: true,
          hidden: true
        }).addTo(map)
        this.map = map
      } else {
        this.masklayer.bringToFront()
        this.map = map
      }
      this.map.on('zoomend', e => {
        this.zoomFn(e)
      })
    },
    zoomFn (e) {
      let arr = []
      this.Global.filterArr(arr, this.layerDeal(this.ylzMarkers), this.layerDeal(this.hdzMarkers), this.layerDeal(this.skzMarkers))
      if (e.target._zoom > 12) {
        arr.forEach(el => {
          el.unbindTooltip()
          el.bindTooltip(el.options.tooltipShow, { permanent: true, sticky: true })
        })
      } else {
        for (const key in this.map._layers) {
          let el = this.map._layers[key]
          if (el.options.tooltipShow) {
            el.unbindTooltip()
            el.bindTooltip(el.options.tooltipShow, { permanent: false, sticky: true })
          }
        }
      }
    },
    layerDeal (layer) { // 提取图层中的锚点
      let arr = []
      if (layer) {
        for (const key in layer._layers) {
          arr.push(layer._layers[key])
        }
      }
      return arr
    },
    drawBoundary (blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach((item, index) => {
          item.forEach(it => {
            points.push({ lat: it[1], lng: it[0] })
            // console.log(points, 999)
          })
          // points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        // console.log(pArray, 111)
        pArray.push(pArray[0])
      }
      // debugger
      // 添加遮蔽层
      // console.log(pArray, 789)
      var plyall = L.polygon(pArray, { color: 'transparent', Opacity: 0.5, fillColor: '#1752F9', fillOpacity: 0.3 }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    drawPoint (arr, name) {
      if (this.imageLayer) {
        this.map.removeLayer(this.imageLayer)
      }
      if (name === '雨量站' && this.typename === '降雨等值面') {
        this.getRianGraph()
      }
      let myIcon
      let layers = []
      if (name === '雨量站') {
        this.rainTip.forEach(item => {
          item.val = 0
        })
      }
      arr.forEach((item, index) => {
        let iconUrl = null
        if (name === '雨量站') {
          iconUrl = require('@/assets/topicscreen_img_ptcopy/ylcj.png')
          if (item.accRain === 0 || item.accRain === undefined) {
            iconUrl = require('@/assets/homepage_img_ptcopy/0.png')
            this.rainTip[0].val++
          } else if (item.accRain < 10) {
            iconUrl = require('@/assets/homepage_img_ptcopy/0-10.png')
            this.rainTip[1].val++
          } else if (item.accRain < 25) {
            iconUrl = require('@/assets/homepage_img_ptcopy/10-25.png')
            this.rainTip[2].val++
          } else if (item.accRain < 50) {
            iconUrl = require('@/assets/homepage_img_ptcopy/25-50.png')
            this.rainTip[3].val++
          } else if (item.accRain < 100) {
            iconUrl = require('@/assets/homepage_img_ptcopy/50-100.png')
            this.rainTip[4].val++
          } else if (item.accRain < 250) {
            iconUrl = require('@/assets/homepage_img_ptcopy/100-250.png')
            this.rainTip[5].val++
          } else {
            iconUrl = require('@/assets/homepage_img_ptcopy/250.png')
            this.rainTip[6].val++
          }
          myIcon = L.icon({
            iconUrl: iconUrl,
            iconAnchor: [8, 8],
            iconSize: [13, 13]
          })
        } else if (name === '河道站') {
          if (item.overflowGuaranteeWater > 0) {
            iconUrl = require('@/assets/homepage_img_ptcopy/river_cj.png')
          } else {
            iconUrl = require('@/assets/homepage_img_ptcopy/river.png')
          }
          myIcon = L.icon({
            iconUrl: iconUrl,
            iconAnchor: [8, 8],
            iconSize: [20, 20]
          })
        } else if (name === '水库站') {
          if (item.overflowWarningWater > 0) {
            iconUrl = require('@/assets/homepage_img_ptcopy/river_cj.png')
          } else {
            iconUrl = require('@/assets/homepage_img_ptcopy/river.png')
          }
          myIcon = L.icon({
            iconUrl: iconUrl,
            iconAnchor: [8, 8],
            iconSize: [18, 18]
          })
        } else if (name === '高亮') {
          myIcon = L.icon({
            iconUrl: require('@/assets/homepage_img_ptcopy/gl.gif'),
            iconSize: [30, 30]
          })
        }
        let html = ''
        if (this.tabsIndex === 0) {
          html = `<b>${item.stnm} </b> 雨量:${(item.accRain || item.accRain === 0) ? item.accRain : '-'}mm`
        } else {
          html = `<b>${item.stnm} </b> 水位:${(item.water || item.water === 0) ? item.water.toFixed(2) : '-'}m`
        }
        let markersname = item.stid || item.id
        let markers = L.marker([item.lttd, item.lgtd], {
          icon: myIcon,
          data: item,
          name: markersname, // 以id或stid为唯一标识
          tooltipShow: html
        })
        markers.bindTooltip(html, {
          permanent: this.map._zoom > 12,
          sticky: true,
          className: 'anim-tooltip'
        })
        markers.on('click', (e) => {
          let tempSTID = item.stid ? item.stid : item.id
          if (this.tabsIndex === 0 && item.sttp.includes('RR')) {
            api.getStatisticsReservoirWater({
              SID: this.$store.state.sid,
              STID: tempSTID
            }).then(res => {
              let data = res.data.rows[0] || {}
              item.impoundmentRate = data.impoundmentRate ? data.impoundmentRate : null
              this.$refs.stationDialog.showlog(item)
            })
          } else {
            this.$refs.stationDialog.showlog(item)
          }
          this.$emit('setRow', tempSTID, item.sttp)
        })
        layers.push(markers)
      })
      if (name === '雨量站') {
        this.ylzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.ylzMarkers)
      } else if (name === '河道站') {
        this.hdzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.hdzMarkers)
      } else if (name === '水库站') {
        this.skzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.skzMarkers)
      } else if (name === '高亮') {
        this.glMarkers = L.layerGroup(layers)
        this.map.addLayer(this.glMarkers)
      }
    },
    showDialog (item) {
      let tempSTID = item.stid ? item.stid : item.id
      if (this.tabsIndex === 0 && item.sttp.includes('RR')) {
        api.getStatisticsReservoirWater({
          SID: this.$store.state.sid,
          STID: tempSTID
        }).then(res => {
          let data = res.data.rows[0] || {}
          item.impoundmentRate = data.impoundmentRate ? data.impoundmentRate : null
          this.$refs.stationDialog.showlog(item)
        })
      } else {
        this.$refs.stationDialog.showlog(item)
      }
    },
    closeDialog () {
      this.$refs.stationDialog.closeLog()
    },
    showPoint (item) {
      let arr = [item]
      if (this.glMarkers) {
        this.glMarkers.clearLayers()
        this.glMarkers = null
      }
      this.drawPoint(arr, '高亮')
      this.map.setView([item.lttd, item.lgtd], 11)
    },
    getCurrentTime (hour) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 60 * 60 * 1000 * Number(hour))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (mm > 9 ? mm : '0' + mm)
      return time
    },
    // 生成等值降雨面
    getRianGraph () {
      // eventbus.$on('theraintime', (timearr) => { // 这里最好用箭头函数，不然this指向有问题
      // if (this.imageLayer) {
      //   this.map.removeLayer(this.imageLayer)
      // }
      if (this.timearr.length === 0) {
        this.timearr = [this.getCurrentTime(1), this.getCurrentTime(0)]
      }
      this.graphLoading = true
      this.loading = true
      let _this = this
      // let map = this.map
      let tempUnitInput = Number(_this.unitInput)
      let tempGrade = ''
      if (_this.isCustomStr) {
        tempGrade = '0,' + tempUnitInput + ',' + 2 * tempUnitInput + ',' + 3 * tempUnitInput + ',' + 4 * tempUnitInput + ',' + 5 * tempUnitInput
      } else {
        tempGrade = '0,10,25,50,100,250'
      }
      this.$store.dispatch(comprehensiveMapTypes.GET_RAIN_GRAPH, {
        beginTime: this.timearr[0],
        endTime: this.timearr[1],
        grade: tempGrade
      }).then(data => {
        this.loading = false
        let baseUrl = config.ApiYJ
        let imageUrl = baseUrl + data.path
        let imageBounds = [[28.615260, 120.326890], [28.015156, 120.983099]]
        this.imageLayer = L.imageOverlay(imageUrl, imageBounds)
        this.imageLayer.addTo(this.map)
        // if (this.imageLayer != null) {
        //   this.imageLayer.setUrl(imageUrl)
        // }
        // _this.graphLoading = false
        // let imageLayerdraw = true
        // eventbus.$emit('imageLayer', imageLayerdraw) // $emit这个方法会触发一个事件
      }).catch(() => {})
      // })
    }
  },
  created () {
    eventbus.$on('theraintime', (timearr) => {
      this.timearr = timearr
    }) // 这里最好用箭头函数，不然this指向有问题
    eventbus.$on('typeselect', (label) => {
      this.typename = label
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted () {
    this.leaflet(3)
    this.timer = setInterval(() => {
      if (this.hdzMarkers) {
        this.hdzMarkers.clearLayers()
        this.hdzMarkers = null
      }
      if (this.skzMarkers) {
        this.skzMarkers.clearLayers()
        this.skzMarkers = null
      }
      if (this.tabsIndex === 0) {
      } else {
        this.getStatisticsRiverWater()
        this.getStatisticsReservoirWater()
      }
    }, 1000 * 60 * 5)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang='less' scoped>
.centermap{
  width: 100%;
  height: 100%;
  #centermap {
    width: 100%;
    height: 100%;
    margin-top: -65px;
    position: relative;
  }
}
.tip{
  position: absolute;
  bottom: 10px;
  z-index: 500;
  left: 550px;
  font-size: 16px;
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid #00eaff;
  border-radius: 5px;
  padding: 5px 10px;
  transition: all 1s ease;
  .tip_tab{
    width: 40px;
    font-size: 18px;
    color: #00eaff;
    border-bottom: 2px solid #00eaff;
    line-height: 24px;
  }
  .tip_con{
    height: 24px;
    line-height: 24px;
    justify-content: center;
    .tip_div{
      margin-right: 15px;
    }
    img{
      width: 16px;
      height: 16px;
      padding-right: 4px;
    }
  }
  .tipDiv{
    width: 100%;
    .tipli{
      height: 100%;
      padding-left: 5px;
      font-size: 20px;
      justify-content: center;
      // border-right: 1px solid #3f4c6f;
      position: relative;
      img{
        height: 68px;
        margin-right: 5px;
      }
      .rightTip{
        width: 68px;
        height: 68px;
        align-items: flex-start;
        justify-content: space-between;
        div{
          &:nth-of-type(1){
            color: #c9f7f7;
            font-size: 14px;
          }
          &:nth-of-type(2){
            line-height: 40px;
            font-size: 30px;
          }
        }
      }
    }
  }
}
.tipleft{
  left: 20px;
}
.flexDiv {
  /* 横向排列 */
  display: flex;
  align-items: center;
}
.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flexFS {
  /* 左对齐 */
  justify-content: flex-start;
}
.flexFE {
  /* 右对齐 */
  justify-content: flex-end;
}
.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}
.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}
/deep/ #centermap {
  img.leaflet-image-layer.leaflet-zoom-animated {
    opacity: 0.7;
  }
}
</style>
